import axios from 'axios';

export const fetch = (type, path) => async dispatch => {
  const url =
    process.env.NODE_ENV !== 'development'
      ? process.env.REACT_APP_API
      : `${window.location.protocol}//${window.location.hostname}:3004`;

  dispatch({
    type: `REQUEST_${type}`
  });
  try {
    const response = await axios({
      withCredentials: true,
      url: url + path
    });
    if (response.status === 200) {
      dispatch({
        type: `SUCCESS_${type}`,
        payload: response.data
      });
    } else {
      throw Error;
    }
  } catch (error) {
    dispatch({
      type: `ERROR_${type}`,
      payload: error
    });
  }
};

export const getFiles = id =>
  fetch('PROVIDER_RESOURCE_FILES', `/getFiles?tab_pane=${id}`);

export const getProviders = () => fetch('PROVIDERS', '/getProviders');

export const getProviderDetails = id =>
  fetch('PROVIDER_DETAILS', `/getProviderDetail?provider=${id}`);

export const getProviderNews = () =>
  fetch('PROVIDER_RESOURCE_NEWS', `/getProviderNews`);

export const getError = () => ({
  type: 'ERROR_PROVIDER_DETAILS',
  payload: true
});
